var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Sold","mini":"true"}}),_c('ContentRow',[_c('ContentContainer',[_c('Listings',{attrs:{"filter":_vm.listingFilter}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }